var $ = require('jquery');

"use strict";

//doplnit pluginName
var PLUGIN_NAME = "productVariantSelect";
var PLUGIN_VERSION = "v1.0";

var DEFAULTS = {
	primaryContainer: '.js_product-detail-container',
	containers: ['.js_product-detail-pu-container']
};

/**
 * set basic variables
 * create options and settings for this instance
 * @param element - DOM Element the plugin is applied to
 * @param options - custom settings to be merged with DEFAULTS
 * @constructor
 */
var ProductVariantSelect = function (element, options) {
	this.element = element;
	this.$t = $(this.element);
	this.variantSelected = false;

	// merge options
	this.options = $.extend(true, {}, DEFAULTS, options);
	this._defaults = DEFAULTS;
	this.initialise();
};

/**
 * init function
 */
ProductVariantSelect.prototype.initialise = function () {
	var self = this;
	self.handleEvents();
	self.updateOptionState();
	history.replaceState({updatedContainers: self.options.containers}, document.title, window.location.href);
};

ProductVariantSelect.prototype.handleEvents = function () {
	var self = this;
	$(self.options.primaryContainer).on('change', '.js_product-variant-select select', function() {
		var selectedVariantsArr = $('.js_product-variant-select select', self.$t).has('option:selected[value!=""]');
		if(selectedVariantsArr.size() != $('.js_product-variant-select select', self.$t).size()) {
			self.updateOptionState();
			if(self.variantSelected) {
				self.loadVariantDetail();
			}
			self.variantSelected = false;
		} else {
			self.loadVariantDetail(selectedVariantsArr);
			self.variantSelected = true;
		}
	});
};

ProductVariantSelect.prototype.updateOptionState = function () {
	var self = this;
	$('.js_product-variant-select select', self.$t).each(function() {
		var selectedVariants = [];

		$('.js_product-variant-select select', self.$t).has('option:selected[value!=""]').not(this).each(function() {
			var variantCode = $(this).attr('name').match(/v\[(.*)\]/)[1];
			selectedVariants.push({code: variantCode, value: $(this).val()});
		});

		$('option', this).each(function() {
			var isVariantAvailable = false;
			var itemVariantCode = $(this).parent('select').attr('name').match(/v\[(.*)\]/)[1];
			var itemValue = $(this).val();

			for(var i = 0; i < parameterVariantProductList.length; i++) {
				var availableCombination = parameterVariantProductList[i].parameterList;

				if(self.findObjectInArr(availableCombination, itemVariantCode, itemValue)) {
					isVariantAvailable = true;
				}

				if(isVariantAvailable && selectedVariants.length > 0) {
					for (var j = 0; j < selectedVariants.length; j++) {
						if(self.findObjectInArr(availableCombination, selectedVariants[j].code, selectedVariants[j].value)) {
							isVariantAvailable = true;
						} else {
							isVariantAvailable = false;
							break;
						}
					}
				}
				if(isVariantAvailable) {
					break;
				}
			}

			if(isVariantAvailable) {
				$(this).show();
			} else {
				if($(this).is(':selected')) {
					$(this).parent('select').val('');
				}
				$(this).hide();
			}
		});
	});
};

ProductVariantSelect.prototype.findObjectInArr = function (array, type, code) {
	var self = this;
	var obj = array.filter(function(obj) {
		return obj.type === type && obj.code === code;
	});

	if(obj.length > 0) {
		return true;
	}
	return false;
};

ProductVariantSelect.prototype.loadVariantDetail = function (selectedVariants) {
	var self = this;
	var targetUrl = "";

	if(typeof selectedVariants !== 'undefined') {
		for(var i = 0; i < parameterVariantProductList.length; i++) {
			var availableCombination = parameterVariantProductList[i].parameterList;
			var isTargetVariant = true;

			for(var j = 0; j < selectedVariants.length; j++) {
				var itemVariantCode = $(selectedVariants[j]).attr('name').match(/v\[(.*)\]/)[1];
				var itemValue = $(selectedVariants[j]).val();
				if(!self.findObjectInArr(availableCombination, itemVariantCode, itemValue)) {
					isTargetVariant = false;
					break;
				}
			}

			if(isTargetVariant) {
				targetUrl = parameterVariantProductList[i].entityUrl;
				break;
			}
		}
	} else {
		targetUrl = self.$t.attr('action');
	}

	if(targetUrl != "") {
		$(document).trigger('FG_UNIVERSAL_PRELOADER_START', 'PRODUCTDETAIL_VARIANT_CHANGE');
		$.get(targetUrl, function(data) {
			var containers = self.options.containers;
			for(var i = 0; i < containers.length; i++) {
				$(containers[i], self.$t).html($(data).find(containers[i]+'>*'));
			}
			history.pushState({updatedContainers: containers, events: ['EDEESHOP_PRODUCTDETAIL_VARIANT_CHANGED'], primaryContainer: self.options.primaryContainer}, document.title, targetUrl);
			self.$t.trigger('EDEESHOP_PRODUCTDETAIL_VARIANT_CHANGED');
			self.updateOptionState();
			$(document).trigger('FG_UNIVERSAL_PRELOADER_STOP', 'PRODUCTDETAIL_VARIANT_CHANGE');
		});
	}
};

/**
 * decide, which methods will be "public"
 */
var API = {
	//method: PluginSkeleton.prototype.method
	//loadMarkers: GoogleMap.prototype.loadMarkers
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *    if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *    if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			//doplnit PluginName
			plugin = new ProductVariantSelect(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};

/**
 * setDefaults with $.pluginSkeleton.setDefaults();
 */
$[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
$[PLUGIN_NAME].setDefaults = function (newOptions) {
	DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
};


// WEBPACK FOOTER //
// ./node_modules/fg-frontend/edeeshop/jquery.product-variant-select.js